import { LargeBlackBlockquote } from '../../components/blockquote/LargeBlackBlockquote';
import { LargeGrayBlockquote } from '../../components/blockquote/LargeGrayBlockquote';
import { MediumBlackBlockquote } from '../../components/blockquote/MediumBlackBlockquote';
import { MediumGrayBlockquote } from '../../components/blockquote/MediumGrayBlockquote';
import { SmallBlackBlockquote } from '../../components/blockquote/SmallBlackBlockquote';
import { SmallGrayBlockquote } from '../../components/blockquote/SmallGrayBlockquote';
import { BaseHeading } from '../../components/heading/BaseHeading';
import { GrayHeading } from '../../components/heading/GrayHeading';
import { LargeBlackList } from '../../components/list/LargeBlackList';
import { LargeGrayList } from '../../components/list/LargeGrayList';
import { MediumBlackList } from '../../components/list/MediumBlackList';
import { MediumGrayList } from '../../components/list/MediumGrayList';
import { SmallBlackList } from '../../components/list/SmallBlackList';
import { SmallGrayList } from '../../components/list/SmallGrayList';
import { LargeBlackParagraph } from '../../components/paragraphs/LargeBlackParagraph';
import { LargeGrayParagraph } from '../../components/paragraphs/LargeGrayParagraph';
import { MediumBlackParagraph } from '../../components/paragraphs/MediumBlackParagraph';
import { MediumGrayParagraph } from '../../components/paragraphs/MediumGrayParagraph';
import { SmallBlackParagraph } from '../../components/paragraphs/SmallBlackParagraph';
import { SmallGrayParagraph } from '../../components/paragraphs/SmallGrayParagraph';

export const getComponents = ({
	color,
	size
}: {
	color: 'black' | 'gray';
	size: 'small' | 'medium' | 'large';
}) => {
	if (color === 'gray') {
		if (size === 'small') {
			return {
				paragraph: SmallGrayParagraph,
				list: SmallGrayList,
				blockquote: SmallGrayBlockquote,
				heading: GrayHeading
			};
		} else if (size === 'medium') {
			return {
				paragraph: MediumGrayParagraph,
				list: MediumGrayList,
				blockquote: MediumGrayBlockquote,
				heading: GrayHeading
			};
		} else {
			return {
				paragraph: LargeGrayParagraph,
				list: LargeGrayList,
				blockquote: LargeGrayBlockquote,
				heading: GrayHeading
			};
		}
	}

	if (size === 'small') {
		return {
			paragraph: SmallBlackParagraph,
			list: SmallBlackList,
			blockquote: SmallBlackBlockquote,
			heading: BaseHeading
		};
	} else if (size === 'medium') {
		return {
			paragraph: MediumBlackParagraph,
			list: MediumBlackList,
			blockquote: MediumBlackBlockquote,
			heading: BaseHeading
		};
	} else {
		return {
			paragraph: LargeBlackParagraph,
			list: LargeBlackList,
			blockquote: LargeBlackBlockquote,
			heading: BaseHeading
		};
	}
};
